/* Panier-tiroir : moteur branché sur l'API Cart AJAX de Shopify.
   Reprend le contrat de classes des maquettes (partials/panier.css).
   La section panier-tiroir fournit la racine [data-panier-tiroir] avec la
   config (seuil, upsells, best-sellers, libellés) et l'état initial du panier. */
(function () {
  var d = document.documentElement;
  var racine = document.querySelector('[data-panier-tiroir]');
  if (!racine) return;

  var SEUIL_PROCHE = 0.5;
  var UNDO_MS = 5000;
  var MAX_UPSELL = 3;

  var L = {};
  var config = { seuil: 0, upsells: [], bests: [] };
  try {
    L = JSON.parse(racine.querySelector('[data-pt-libelles]').textContent);
    config = JSON.parse(racine.querySelector('[data-pt-config]').textContent);
  } catch (e) { return; }

  var cart = null;
  try { cart = JSON.parse(racine.querySelector('[data-pt-cart]').textContent); } catch (e) { cart = { items: [], item_count: 0, items_subtotal_price: 0 }; }

  var erreur = null;            /* { cle, message } sous une ligne */
  var annulation = null;        /* { item, timer } suppression en attente */
  var confettisJoues = false;
  var barreEnAttente = '';
  var timerAnnonce = null;
  var retourFocus = null;

  function fmt(c) {
    var e = Math.floor(c / 100), dec = Math.round(c % 100);
    return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + (dec < 10 ? '0' : '') + dec + ' €';
  }
  function fmtCourt(c) {
    if (c % 100 === 0) return String(c / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
    return fmt(c);
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function sousTotal() { return cart ? cart.items_subtotal_price : 0; }
  /* seuil de livraison offerte : sur le total après remises, comme la page
     panier (cart.total_price) et les tarifs Shopify « selon le prix » */
  function totalRemise() { return cart ? cart.total_price : 0; }
  function nbArticles() { return cart ? cart.item_count : 0; }

  /* ===== Squelette du tiroir ===== */
  var overlay = document.createElement('div');
  overlay.className = 'pt-overlay';
  var drawer = document.createElement('aside');
  drawer.className = 'pt-drawer';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('aria-label', L.panier || 'Panier');
  drawer.setAttribute('tabindex', '-1');
  drawer.innerHTML =
    '<div class="pt-head">' +
      '<p class="pt-titre">' + esc(L.titre || 'Ton panier') + '</p>' +
      '<span class="pt-count" aria-hidden="true"></span>' +
      '<button class="pt-close" type="button" aria-label="' + esc(L.fermer || 'Fermer le panier') + '">×</button>' +
    '</div>' +
    '<div class="pt-barre" hidden>' +
      '<p class="pt-barre-txt"></p>' +
      '<div class="pt-barre-jauge" aria-hidden="true"><span class="pt-barre-fill"></span></div>' +
    '</div>' +
    '<div class="pt-corps"></div>' +
    '<div class="pt-foot" hidden><div data-pt-foot-haut></div></div>';
  var live = document.createElement('p');
  live.className = 'pt-live';
  live.setAttribute('aria-live', 'polite');
  document.body.appendChild(overlay);
  document.body.appendChild(drawer);
  document.body.appendChild(live);

  var elCount = drawer.querySelector('.pt-count');
  var barre = drawer.querySelector('.pt-barre');
  var barreTxt = drawer.querySelector('.pt-barre-txt');
  var barreFill = drawer.querySelector('.pt-barre-fill');
  var corps = drawer.querySelector('.pt-corps');
  var foot = drawer.querySelector('.pt-foot');
  var footHaut = foot.querySelector('[data-pt-foot-haut]');

  /* Blocs persistants du pied : les boutons de paiement rapide rendus par
     Shopify (Apple Pay, PayPal…) sont déplacés une seule fois depuis la
     section — les recréer à chaque rendu casserait leurs iframes. */
  var express = racine.querySelector('[data-pt-express]');
  if (express) {
    foot.appendChild(express);
    express.hidden = false;
  }
  var reassurance = document.createElement('p');
  reassurance.className = 'pt-reassurance';
  reassurance.innerHTML =
    '<span>' + esc(L.reassure_2 || 'Retours faciles') + '</span>' +
    '<span>' + esc(L.reassure_3 || 'Paiement sécurisé') + '</span>';
  foot.appendChild(reassurance);

  function annoncer(message) {
    clearTimeout(timerAnnonce);
    timerAnnonce = setTimeout(function () {
      if (barreEnAttente) {
        message += (/[.!?]$/.test(message) ? ' ' : '. ') + barreEnAttente;
        barreEnAttente = '';
      }
      live.textContent = '';
      live.textContent = message;
    }, 60);
  }

  /* ===== Barre livraison offerte ===== */
  function etatBarre() {
    if (!config.seuil) return 'ok';
    var total = totalRemise();
    if (total >= config.seuil) return 'ok';
    return total >= config.seuil * SEUIL_PROCHE ? 'proche' : 'loin';
  }
  function texteBarre(e) {
    if (e === 'ok') return L.barre_ok || 'Livraison offerte débloquée 🎉';
    if (e === 'proche') {
      return (L.barre_plus_que || 'Plus que') + ' ' + fmt(config.seuil - totalRemise()) + ' ' + (L.barre_pour || 'pour la livraison offerte en France !');
    }
    return (L.barre_des || 'Livraison offerte en France dès') + ' ' + fmtCourt(config.seuil);
  }
  function confettis() {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var couche = document.createElement('div');
    couche.className = 'pt-barre-fx';
    couche.setAttribute('aria-hidden', 'true');
    var teintes = ['#ff0000', '#ff4d00', '#2ee56e', '#22d3ee', '#fde047'];
    for (var i = 0; i < 16; i++) {
      var p = document.createElement('i');
      p.style.left = (4 + Math.random() * 92) + '%';
      p.style.background = teintes[i % teintes.length];
      p.style.setProperty('--dx', (Math.random() * 44 - 22).toFixed(0) + 'px');
      p.style.setProperty('--dy', (-18 - Math.random() * 30).toFixed(0) + 'px');
      p.style.setProperty('--rot', (Math.random() * 220 - 110).toFixed(0) + 'deg');
      p.style.animationDelay = (Math.random() * 0.12).toFixed(2) + 's';
      couche.appendChild(p);
    }
    barre.appendChild(couche);
    setTimeout(function () { couche.remove(); }, 950);
  }
  function majBarre() {
    var visible = !!config.seuil && cart.items.length > 0;
    barre.hidden = !visible;
    if (!visible) return;
    var e = etatBarre();
    var avait = barre.className;
    barre.className = 'pt-barre est-' + e;
    barreTxt.textContent = texteBarre(e);
    var part = config.seuil ? Math.min(1, totalRemise() / config.seuil) : 1;
    barreFill.style.transform = 'scaleX(' + part + ')';
    if (e === 'ok' && avait.indexOf('est-ok') === -1 && !confettisJoues) {
      confettisJoues = true;
      confettis();
      barreEnAttente = L.barre_ok_annonce || 'Livraison offerte débloquée !';
    }
  }

  /* ===== Suggestions ===== */
  function dansPanier(idVariante) {
    return cart.items.some(function (it) { return it.variant_id === idVariante; });
  }
  function suggestions() {
    if (!cart.items.length) return [];
    var libres = config.upsells.filter(function (p) { return !dansPanier(p.id); });
    var ecart = Math.max(0, config.seuil - totalRemise());
    libres.sort(function (a, b) {
      if (ecart) {
        var aComble = a.prix >= ecart ? 0 : 1;
        var bComble = b.prix >= ecart ? 0 : 1;
        if (aComble !== bComble) return aComble - bComble;
      }
      return a.prix - b.prix;
    });
    return libres.slice(0, MAX_UPSELL);
  }

  /* ===== Rendus ===== */
  /* propriétés posées par le formulaire carte cadeau (noms imposés par
     Shopify, en anglais) : affichées en français, date au format du site */
  var CADEAU_LIBELLES = {
    'Recipient name': L.cadeau_pour || 'Pour',
    'Recipient email': L.cadeau_email || 'E-mail',
    'Message': L.cadeau_message || 'Message',
    'Send on': L.cadeau_envoi || 'Envoi le'
  };
  function texteOptions(item) {
    var morceaux = [];
    if (item.variant_title && item.variant_title !== 'Default Title') morceaux.push(item.variant_title);
    if (item.properties && item.properties._recap) morceaux.push(String(item.properties._recap));
    if (item.properties) {
      for (var k in item.properties) {
        if (k.charAt(0) === '_' || !item.properties[k]) continue;
        var v = String(item.properties[k]);
        if (v.indexOf('/') === 0 || v.indexOf('http') === 0) continue; /* fichiers déposés */
        var lib = CADEAU_LIBELLES[k] || k;
        if (k === 'Send on' && /^\d{4}-\d{2}-\d{2}$/.test(v)) v = v.split('-').reverse().join('/');
        morceaux.push(lib + ' : ' + v);
      }
    }
    return morceaux.join(' · ');
  }
  function htmlLigne(item, indexAjout) {
    var nom = esc(item.product_title);
    var opts = texteOptions(item);
    var err = erreur && erreur.cle === item.key ? erreur.message : '';
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_144x$1$2') : '';
    return '<article class="pt-ligne' + (indexAjout ? ' pt-ligne-in' : '') + '" data-cle="' + esc(item.key) + '">' +
      '<a class="pt-vign" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="pt-ligne-corps">' +
        '<a class="pt-nom" href="' + esc(item.url) + '">' + nom + '</a>' +
        (opts ? '<p class="pt-opts">' + esc(opts) + '</p>' : '') +
        '<div class="pt-ligne-bas">' +
          '<span class="pt-qte">' +
            '<button type="button" data-moins aria-label="' + esc(L.diminuer || 'Diminuer la quantité de') + ' ' + nom + '">−</button>' +
            '<span class="pt-qte-val">' + item.quantity + '</span>' +
            '<button type="button" data-plus aria-label="' + esc(L.augmenter || 'Augmenter la quantité de') + ' ' + nom + '">+</button>' +
          '</span>' +
          '<button class="pt-suppr" type="button" data-suppr aria-label="' + esc(L.retirer || 'Retirer') + ' ' + nom + '">' + esc(L.retirer || 'Retirer') + '</button>' +
          '<span class="pt-prix">' + fmt(item.final_line_price) + '</span>' +
        '</div>' +
        (err ? '<p class="pt-erreur">' + esc(err) + '</p>' : '') +
      '</div>' +
    '</article>';
  }
  function htmlCarteUpsell(p) {
    var nom = esc(p.nom);
    return '<article class="pt-up-carte">' +
      '<span class="pt-up-vign" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<div class="pt-up-corps">' +
        '<b class="pt-up-nom">' + nom + '</b>' +
        '<span class="pt-up-prix">' + fmt(p.prix) + '</span>' +
      '</div>' +
      '<button class="pt-up-add" type="button" data-ajout="' + p.id + '" aria-label="' + esc(L.ajouter_label || 'Ajouter') + ' ' + nom + '">+ ' + esc(L.ajouter || 'Ajouter') + '</button>' +
    '</article>';
  }
  function htmlVide() {
    var cartes = '';
    config.bests.forEach(function (p) { cartes += htmlCarteUpsell(p); });
    return '<div class="pt-vide">' +
      '<p class="pt-vide-t">' + esc(L.vide_titre || 'Ton panier est vide') + '</p>' +
      (cartes ? '<p class="pt-vide-s">' + esc(L.vide_sous || 'Nos best-sellers pour commencer :') + '</p>' + cartes : '') +
      '<button class="pt-vide-lien" type="button" data-fermer>' + esc(L.continuer || 'Continuer mes achats') + '</button>' +
    '</div>';
  }
  function htmlUpsell() {
    var liste = suggestions();
    if (!liste.length) return '';
    var html = '';
    liste.forEach(function (p) { html += htmlCarteUpsell(p); });
    return '<section class="pt-upsell" aria-labelledby="pt-upsell-t">' +
      '<h2 class="pt-upsell-t" id="pt-upsell-t">' + esc(L.upsell_titre || 'Complète ton setup') + '</h2>' + html +
    '</section>';
  }
  /* Encart « collection à découvrir » (Collection Miami, 2026-10-31) : séparé des
     vrais produits du panier par « À découvrir aussi », cadre violet, bannière,
     2 produits en photo (pas d'ajout direct : il faut une taille), bouton. */
  function htmlEncart() {
    var e = config.encart;
    if (!e || !e.produits || !e.produits.length) return '';
    var cartes = '';
    e.produits.slice(0, 2).forEach(function (p) {
      cartes += '<a class="pt-mi-carte" href="' + esc(p.url) + '">' +
        '<span class="pt-mi-ph"><img src="' + esc(p.img) + '" alt="' + esc(p.nom) + '" loading="lazy">' +
          (p.img2 ? '<img class="pt-mi-ph2" src="' + esc(p.img2) + '" alt="" aria-hidden="true" loading="lazy">' : '') + '</span>' +
        '<span class="pt-mi-nom">' + esc(p.nom) + '</span>' +
        '<span class="pt-mi-prix">' + fmt(p.prix) + '</span>' +
      '</a>';
    });
    return '<p class="pt-mi-sep">' + esc(e.sep || 'À découvrir aussi') + '</p>' +
      '<section class="pt-mi" aria-label="' + esc(e.titre) + '">' +
        '<a class="pt-mi-banniere" href="' + esc(e.url) + '">' +
          (e.img ? '<img src="' + esc(e.img) + '" alt="" loading="lazy">' : '') +
          '<span class="pt-mi-txt">' + (e.kicker ? '<span class="pt-mi-kicker">' + esc(e.kicker) + '</span>' : '') +
            '<b>' + esc(e.titre) + '</b></span>' +
        '</a>' +
        '<div class="pt-mi-duo">' + cartes + '</div>' +
        '<a class="pt-mi-btn" href="' + esc(e.url) + '">' + esc(e.bouton || 'Découvrir la collection') + ' →</a>' +
      '</section>';
  }
  function htmlFoot() {
    if (!cart.items.length) return '';
    var ok = etatBarre() === 'ok';
    return '<div class="pt-sous-total"><span>' + esc(L.sous_total || 'Sous-total') + '</span><b>' + fmt(sousTotal()) + '</b></div>' +
      '<p class="pt-livraison' + (ok ? ' est-ok' : '') + '">' +
        (ok ? esc(L.livraison_ok || 'Livraison offerte en France') + ' <span aria-hidden="true">✓</span>' : esc(L.livraison_checkout || 'Livraison calculée à l’étape suivante')) +
      '</p>' +
      '<a class="btn btn-checkout" href="' + ((window.Shopify && Shopify.routes ? Shopify.routes.root : '/')) + 'checkout">' + esc(L.valider || 'VALIDER MA COMMANDE') +
        '<svg class="pt-fleche" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M2.5 8h10M8.6 3.6 13 8l-4.4 4.4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</a>';
  }
  function majBadges(n) {
    /* le header ne rend la pastille que si le panier a des articles au
       chargement : après un ajout rapide sur un panier vide, on la crée */
    var lienHeader = document.querySelector('.icons a[href$="/cart"]');
    if (n && lienHeader && !lienHeader.querySelector('.cart-n')) {
      var neuf = document.createElement('span');
      neuf.className = 'cart-n';
      lienHeader.appendChild(neuf);
    }
    var badges = document.querySelectorAll('[data-panier-count], .icons .cart-n');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      if (n) badges[i].removeAttribute('hidden');
      else badges[i].setAttribute('hidden', '');
    }
  }
  function pluriel(n, mot) { return n > 1 ? mot + 's' : mot; }
  function rendre(cleAjout) {
    var n = nbArticles();
    elCount.textContent = n ? '(' + n + ')' : '';
    drawer.setAttribute('aria-label', n ? (L.panier || 'Panier') + ', ' + n + ' ' + pluriel(n, L.article || 'article') : (L.panier_vide || 'Panier vide'));
    majBadges(n);
    var html = '';
    if (cart.items.length) {
      cart.items.forEach(function (it) { html += htmlLigne(it, it.key === cleAjout); });
      html += htmlUpsell();
      html += htmlEncart();
    } else {
      html = htmlVide();
    }
    corps.innerHTML = html;
    footHaut.innerHTML = htmlFoot();
    foot.hidden = !cart.items.length;
    majBarre();
  }

  /* ===== Mutations ===== */
  function rafraichir(cleAjout) {
    return fetch((Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (c) { cart = c; rendre(cleAjout); return c; })
      .catch(function () { annoncer(L.erreur_reseau || 'Connexion perdue, réessaie.'); return cart; });
  }
  function changer(cle, quantite) {
    erreur = null;
    return fetch((Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cle, quantity: quantite })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (rep) {
            erreur = { cle: cle, message: rep.description || rep.message || (L.erreur_stock || 'Stock insuffisant.') };
            return null;
          });
        }
        return r.json().then(function (c) { cart = c; });
      })
      .catch(function () {
        erreur = { cle: cle, message: L.erreur_reseau || 'Connexion perdue, réessaie.' };
      })
      .then(function () { rendre(); });
  }
  function ajouterVariante(id) {
    return fetch((Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('ajout'); return r.json(); })
      .then(function (item) {
        return rafraichir(item.key).then(function () {
          annoncer((item.product_title || '') + ' ' + (L.ajoute_annonce || 'ajouté au panier.'));
        });
      })
      .catch(function () { annoncer(L.erreur_ajout || 'Impossible d’ajouter ce produit.'); });
  }

  /* ===== Suppression avec annulation ===== */
  function toastUndo(item) {
    fermerUndo();
    var toast = document.createElement('div');
    toast.className = 'pt-undo';
    toast.innerHTML =
      '<span class="pt-undo-txt">' + esc(item.product_title) + ' ' + esc(L.retire_txt || 'retiré') + '</span>' +
      '<button class="pt-undo-btn" type="button">' + esc(L.annuler || 'Annuler') + '</button>' +
      '<span class="pt-undo-vie" aria-hidden="true"></span>';
    drawer.insertBefore(toast, foot);
    var timer = setTimeout(fermerUndo, UNDO_MS);
    annulation = { item: item, toast: toast, timer: timer };
    toast.querySelector('.pt-undo-btn').addEventListener('click', function () {
      var it = annulation ? annulation.item : null;
      fermerUndo();
      if (!it) return;
      fetch((Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: it.variant_id, quantity: it.quantity, properties: it.properties || {} })
      })
        .then(function (r) { if (!r.ok) throw new Error('ajout'); return rafraichir(); })
        .catch(function () { annoncer(L.erreur_ajout || 'Impossible d’ajouter ce produit.'); });
    });
  }
  function fermerUndo() {
    if (!annulation) return;
    clearTimeout(annulation.timer);
    annulation.toast.remove();
    annulation = null;
  }

  /* ===== Ouverture / fermeture ===== */
  function ouvrir() {
    retourFocus = document.activeElement;
    overlay.classList.add('on');
    drawer.classList.add('on');
    d.classList.add('panier-open');
    var close = drawer.querySelector('.pt-close');
    if (close) close.focus();
  }
  function fermer() {
    if (!drawer.classList.contains('on')) return;
    overlay.classList.remove('on');
    drawer.classList.remove('on');
    d.classList.remove('panier-open');
    fermerUndo();
    if (retourFocus && retourFocus.focus) retourFocus.focus();
  }
  window.Panier = { ouvrir: ouvrir, fermer: fermer, rafraichir: rafraichir };

  /* ===== Événements ===== */
  drawer.addEventListener('click', function (e) {
    var cible = e.target;
    var fermeur = cible.closest('.pt-close, [data-fermer]');
    if (fermeur) { fermer(); return; }
    var up = cible.closest('[data-ajout]');
    if (up) { up.disabled = true; ajouterVariante(parseInt(up.getAttribute('data-ajout'), 10)); return; }
    var ligne = cible.closest('.pt-ligne');
    if (!ligne) return;
    var cle = ligne.getAttribute('data-cle');
    var item = null;
    cart.items.forEach(function (it) { if (it.key === cle) item = it; });
    if (!item) return;
    if (cible.closest('[data-plus]')) changer(cle, item.quantity + 1);
    else if (cible.closest('[data-moins]')) {
      if (item.quantity <= 1) { toastUndo(item); changer(cle, 0); }
      else changer(cle, item.quantity - 1);
    } else if (cible.closest('[data-suppr]')) {
      toastUndo(item);
      changer(cle, 0);
      annoncer(item.product_title + ' ' + (L.retire_annonce || 'retiré du panier.'));
    }
  });
  overlay.addEventListener('click', fermer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermer();
  });

  /* Ajout rapide [data-ajout-rapide] (cartes des collections, rail de
     produits, « Complète ton setup » des fiches) : géré ici, dans le script
     chargé sur toutes les pages. Un {% javascript %} de section ne tourne
     que si la section est sur la page, ce qui laissait les fiches sans
     rien. Produits à variante unique seulement : ajout puis tiroir ouvert. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ajout-rapide]');
    if (!btn || drawer.contains(btn)) return;
    e.preventDefault();
    btn.disabled = true;
    ajouterVariante(parseInt(btn.getAttribute('data-ajout-rapide'), 10))
      .then(function () {
        ouvrir();
        document.dispatchEvent(new CustomEvent('supermot:cart:change', { detail: { cart: cart } }));
      })
      .finally(function () { btn.disabled = false; });
  });

  /* l'icône panier du header ouvre le tiroir au lieu de naviguer */
  var lienPanier = document.querySelector('.icons a[href$="/cart"]');
  if (lienPanier) {
    lienPanier.setAttribute('aria-haspopup', 'dialog');
    lienPanier.addEventListener('click', function (e) {
      e.preventDefault();
      ouvrir();
    });
  }

  /* les ajouts au panier faits ailleurs (fiches, ajout rapide) rafraîchissent
     le tiroir et l'ouvrent : le client voit tout de suite où il en est */
  document.addEventListener('supermot:cart:change', function (e) {
    if (e.detail && e.detail.cart) {
      cart = e.detail.cart;
      rendre();
    } else {
      rafraichir();
    }
    ouvrir();
  });

  rendre();
})();
